import React from "react";

export default function Fieldset({ children, className }) {
    return <fieldset className={ className }>{ children }</fieldset>
}